export default {
  NAME_DOSE_NOT_EXIST: "نام وارد نشده است.",
  PERSIAN_NAME_DOSE_NOT_EXIST: "نام فارسی وارد نشده است.",
  PERMISSIONS_DOSE_NOT_EXIST: "دسترسی ها وارد نشده است.",
};
